import React, { useRef, useEffect } from "react";
import classnames from "classnames";
import DeleteIcon from "@mui/icons-material/Delete";
import StarIcon from '@mui/icons-material/Star';
import Tooltip from "@mui/material/Tooltip";

import Radio from "@mui/material/Radio";
import {buildLocationString} from "../utils/utils";

export const LocationItem = ( {
                                  location,
                                  deleteLocation,
                                  isSelected,
                                  setSelectedLocation,
                                  isInitialLocation,
                                  selectOnTextClick
}) => {
    const elementRef = useRef(null);
    const isDefaultLocation = location.is_default_location

    // Scrolls only the list, not the modal body: the picker has two lists and
    // each opens with a selected row.
    useEffect(function scrollElementIntoViewAfterSelecting(){
        const row = elementRef.current
        const list = row?.parentElement
        if (!isSelected || !list) return
        const rowRect = row.getBoundingClientRect()
        const listRect = list.getBoundingClientRect()
        if (rowRect.top >= listRect.top && rowRect.bottom <= listRect.bottom) return
        list.scrollTo?.({
            top: list.scrollTop + rowRect.top - listRect.top - (list.clientHeight - rowRect.height) / 2,
            behavior: 'smooth'
        })
    }, [isSelected])

    return (
        <div
            ref={elementRef}
            className={classnames('LocationItem', {
                selected: isSelected
            })}
        >
            <div>
                <Radio
                    disabled={isSelected}
                    checked={isSelected}
                    onChange={() => setSelectedLocation(location)}
                    className={'LocationItem_checkbox'}
                />
            </div>
            <div
                className={classnames('LocationItem_address', {
                    selected: isSelected,
                    clickable: selectOnTextClick
                })}
                // The delete control lives in a sibling node, so widening the
                // target to the address text can't swallow its clicks.
                onClick={selectOnTextClick && !isSelected ? () => setSelectedLocation(location) : undefined}
            >
                <span>{buildLocationString(location)}</span>
            </div>
            <div>
                {
                    !isInitialLocation && !isDefaultLocation &&
                    <Tooltip title={'Delete Location'} arrow placement={'top'}>
                        <DeleteIcon
                            onClick={() => deleteLocation(location.id)}
                            className={classnames('LocationItem-icon delete', {
                                selected: isSelected
                            })}
                        />
                    </Tooltip>
                }
                {
                    isDefaultLocation &&
                    <Tooltip title={'Default Location'} arrow placement={'top'}>
                        <StarIcon
                            className={classnames('LocationItem-icon star', {
                                selected: isSelected
                            })}
                        />
                    </Tooltip>
                }
            </div>
        </div>
    )
}